import { useAuth0 } from '@auth0/auth0-react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toaster } from '@tempo-io/sui-sonner';
import { NotFoundError } from '@/components/common/error/NotFoundError';
import { ThemeProvider, useTheme } from '@/components/common/theme-provider';
import type { RouterContext } from '@/router';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => {
    return (
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <RootComponent />
      </ThemeProvider>
    );
  },
  notFoundComponent: NotFoundError,
});

function RootComponent() {
  const { isLoading } = useAuth0();
  const { theme } = useTheme();

  if (isLoading) {
    return null;
  }

  return (
    <>
      <div data-testid="e2e-authenticated" className="flex h-screen">
        {!isLoading && <Outlet />}
      </div>
      <Toaster theme={theme} closeButton position="bottom-left" />
      <ReactQueryDevtools initialIsOpen={false} />
      <TanStackRouterDevtools position="bottom-right" />
    </>
  );
}
